export default __webpack_public_path__ + "static/media/rocket_anim_111.de67c5e3.png";